import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { MarketingProduct } from "@/product-marketing/types";
import { PRODUCT_MARKETING } from "./content";
import { ProductBenefits } from "./product-benefits";
import { ProductContact } from "./product-contact";
import { ProductExample } from "./product-example";

export const ProductMarketingPage = ({
  product,
}: {
  product: MarketingProduct;
}) => {
  const content = PRODUCT_MARKETING[product];
  return (
    <section
      aria-labelledby="product-marketing-title"
      className="min-h-full bg-orange-0 text-primary-text"
    >
      <Stack gap="none" className="mx-auto max-w-screen-xl px-8 py-8">
        <Stack
          fullWidth
          className="grid grid-cols-2 items-center gap-10 xl:gap-16"
        >
          <Stack gap="none" className="items-start">
            <Stack direction="row" align="center" gap="sm" className="mb-5">
              <span aria-hidden className="h-px w-7 bg-orange-50" />
              <Typography
                variant="captionW1SemiBold"
                textColor="secondary"
                className="uppercase tracking-widest"
              >
                {content.name}
              </Typography>
            </Stack>
            <h1
              id="product-marketing-title"
              className="font-manrope text-5xl font-extrabold leading-tight tracking-tight"
            >
              {content.title}
              <br />
              <span className="text-orange-60">{content.accentTitle}</span>
            </h1>
            <Typography
              variant="bodyW1"
              textColor="secondary"
              className="mt-5 max-w-md leading-7"
            >
              {content.summary}
            </Typography>
            <ProductContact product={product} />
          </Stack>
          <ProductExample product={product} />
        </Stack>
        <ProductBenefits product={product} />
      </Stack>
    </section>
  );
};
